'use client'
import React from 'react'

import { CardContent } from './CardContent'
import { CardImage } from './CardImage'
import { CardProvider } from './CardProvider'
import { CardRankingTag } from './CardRankingTag'
import { Container, Layout, Variant } from './styles'

export type { CardContentProps } from './CardContent'
export type { CardImageProps } from './CardImage'
export type { CardRankingTagProps } from './CardRankingTag'

export interface CardProps {
  /**
   * Card id
   */
  id?: string

  /**
   * Class name
   */
  className?: string

  /**
   * Card variant
   */
  variant?: Variant

  /**
   * Card layout
   */
  layout?: Layout

  /**
   * Add shadow to the card
   */
  raised?: boolean

  /**
   * Max width
   */
  maxWidth?: number

  /**
   * Card content
   */
  children?: React.ReactNode

  /**
   * onClick handler
   */
  onClick?: () => void
}

type CardComponent = ((props: CardProps) => React.ReactNode) & {
  Image: typeof CardImage
  Content: typeof CardContent
  RankingTag: typeof CardRankingTag
}

/**
 * Card component
 */
export const Card: CardComponent = ({
  id,
  className,
  variant = 'default',
  layout = 'vertical',
  raised = false,
  maxWidth,
  children,
  onClick,
}: CardProps) => {
  return (
    <CardProvider layout={layout}>
      <Container
        id={id}
        className={className}
        variant={variant}
        layout={layout}
        raised={raised}
        maxWidth={maxWidth}
        onClick={
          onClick
            ? (e: React.MouseEvent<HTMLDivElement>) => {
                e.preventDefault()
                onClick()
              }
            : undefined
        }
      >
        {children}
      </Container>
    </CardProvider>
  )
}

Card.Image = CardImage
Card.Content = CardContent
Card.RankingTag = CardRankingTag
